import React from "react";
import Div100vh from "react-div-100vh/lib/Div100vh";
import TopNavbar from "../../topNavbar/TopNavbar";

const VideoPage = (props) => {
  // const mp4Name = "props.mp4Name"

  const data = "/trainingMaterial/" + props.pvUrl + ".mp4";
  // console.log("data= ", data);
  // console.log("pvUrl= ", props.pvUrl);

  return (
    <div style={{ overflowY: "auto" }}>
      <Div100vh>
        <TopNavbar />
        {/* <PageHeader src="/water-bg.jpeg" alt="water-bg"></PageHeader> */}
        {/* <TrainingPageSummary name={this.props.user.name} /> */}
        {/* <br /> */}
        <div
          style={{
            textAlign: "center",
            marginTop: "25px",
            marginBottom: "25px",
          }}
        >
          <video width="80%" height="80%" controls>
            <source src={data} type="video/mp4" />
          </video>
        </div>
      </Div100vh>
    </div>
  );
};

export default VideoPage;
